var zhcn = require('./zhcn')
var enus = require('./enus')
var i18n = {
  zhcn: zhcn,
  enus: enus
}
module.exports = i18n


//////////////////
// WEBPACK FOOTER
// ./i18nData/index.js
// module id = cnn2
// module chunks = 1